import {
  Directive,
  ElementRef,
  HostListener,
  NgZone,
  inject,
  output,
} from '@angular/core';

/**
 * Emits when a pointerdown occurs outside the host element.
 * Apply to any dropdown root so outside clicks close it by default:
 *
 * ```html
 * <div class="menu" (appClickOutside)="close()">
 * ```
 */
@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly ngZone = inject(NgZone);

  readonly appClickOutside = output<PointerEvent>();

  @HostListener('document:pointerdown', ['$event'])
  onDocumentPointerDown(event: PointerEvent) {
    const target = event.target as Node | null;
    const host = this.elementRef.nativeElement;
    if (!target || !host || host.contains(target)) {
      return;
    }

    // Ensure template bindings update even if the event ran outside Angular's zone.
    this.ngZone.run(() => this.appClickOutside.emit(event));
  }
}
